const zdwxy = [{
  path: 'zdwxy_zdwxyxx',
  name: 'zdwxy_zdwxyxx',
  component: () =>
    import('@/components/zdwxy/zdwxyxx'),
  meta: { title: '重大危险源信息', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'zdwxy_zdwxyssjc',
  name: 'zdwxy_zdwxyssjc',
  component: () =>
      import('@/components/zdwxy/zdwxyssjc'),
  meta: { title: '重大危险源实时监测', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'zdwxy_zdwxybjsj',
  name: 'zdwxy_zdwxybjsj',
  component: () =>
      import('@/components/zdwxy/zdwxybjsj'),
  meta: { title: '重大危险报警数据', requireAuth: true, keepAlive: true, permission: true }
}
]
export default zdwxy


// WEBPACK FOOTER //
// ./src/router/zdwxy.js